import { Platform } from '@/constants';
import { AppError } from '@/errors/appError';

export function getPlatform(): Platform {
    let platform;
    switch (true) {
        case location.hostname === 'www.tradeball.com':
        case location.hostname === '5.79.64.136':
        case location.hostname === '178.162.165.24':
        case location.hostname === '37.48.124.53':
        case location.hostname === 'tradeball': //localhost
        case location.hostname === 'tradeball2': //localhost
        case location.hostname === 'tradeballv2': //localhost
        case location.hostname === '192.168.1.241': //localhost
        case location.hostname === '192.168.1.129': //localhost
        case location.hostname === 'localhost': //localhost
        case location.hostname === 'devtoolv3.tradeball.com': //vue3
        case location.hostname === 'v3.tradeball.com': //vue3 prod
            platform = Platform.Tradeball;
            break;
        case location.hostname.includes('.local'): //localhost
        case location.hostname === 'wl.tradeball.com':
        case location.hostname === 'tradeball.bet-bra-staging.com':
        case location.hostname === 'tradeball.bet-bra.com':
        case location.hostname === 'tradeball.betbra.bet.br':
        case location.hostname === 'localhostwl': //localhost
            platform = Platform.Betbra;
            break;
        case location.hostname === 'tradeball.apostasnow-staging.com':
        case location.hostname === 'tradeball.apostasnow.com':
            platform = Platform.Apostasnow;
            break;
        case location.hostname === 'tradeball.apostasbf-staging.com':
        case location.hostname === 'tradeball.apostasbf.com':
            platform = Platform.Apostasbf;
            break;
        case location.hostname === 'tradeball.drinbetzero-staging.com':
        case location.hostname === 'tradeball.drinbetzero.com':
            platform = Platform.Drinbet;
            break;
        case location.hostname === 'tradeball.bolsadeaposta-staging.com':
        case location.hostname === 'tradeball.bolsadeaposta.com':
        case location.hostname === 'tradeball.bolsadeaposta.bet.br':
            platform = Platform.Bolsadeaposta;
            break;
        case location.hostname === 'tradeball.greenwin-staging.com':
        case location.hostname === 'tradeball.greenwin.bet':
            platform = Platform.Greenwin;
            break;
        case location.hostname === 'tradeball.betbox-staging.com':
        case location.hostname === 'tradeball.betbox.bet':
            platform = Platform.Betbox;
            break;
        case location.hostname === 'tradeball.fulltbet-staging.com':
        case location.hostname === 'tradeball.fulltbet.com':
        case location.hostname === 'tradeball.fulltbet.bet.br':
            platform = Platform.Fulltbet;
            break;
        case location.hostname === 'tradeball.verdinhabet-staging.com':
        case location.hostname === 'tradeball.verdinhabet.com':
            platform = Platform.Verdinhabet;
            break;
        case location.hostname === 'tradeball.oddjusta-staging.com':
        case location.hostname === 'tradeball.oddjusta.com':
            platform = Platform.Oddjusta;
            break;
        case location.hostname === 'tradeball.matchbook-staging.com':
        case location.hostname === 'tradeball.matchbook.bet.br':
            platform = Platform.Matchbook;
            break;
        default:
            throw new AppError(`Unknown platform: ${location.hostname}`);
    }

    return platform;
}
